import { isLoggedStore } from '@/store/logged';
import crypto from '@/services/crypto';

// Username (campo `username` della tabella users) autorizzati a eliminare
// clienti, contratti, centrali, impianti, sezioni, inverter, moduli e referenti.
// Per abilitare un altro utente basta aggiungere qui il suo username.
const UTENTI_AUTORIZZATI_CANCELLAZIONE = ['fabiano-buratti'];

// Admin che possono usare anche la parte tecnico (creazione fogli di lavoro).
// Il nome serve al dropdown "Operatore" della segreteria, che altrimenti
// conosce solo gli utenti di tipo tecnico.
const ADMIN_ANCHE_TECNICI = [
  { username: 'federico-pelosi', nome: 'Federico Pelosi' },
];

export default {
  canDelete() {
    const store = isLoggedStore();
    return UTENTI_AUTORIZZATI_CANCELLAZIONE.includes(store.user);
  },

  isAdminTecnico() {
    const store = isLoggedStore();
    return ADMIN_ANCHE_TECNICI.some((u) => u.username === store.user);
  },

  elencoAdminTecnici() {
    return ADMIN_ANCHE_TECNICI;
  },

  // La segreteria vede l'anagrafica in sola visualizzazione:
  // niente pulsanti Aggiungi/Modifica e niente pagine di add/edit.
  canEditAnagrafica() {
    const store = isLoggedStore();
    const tipo = store.tipo ? crypto.decipher(store.tipo) : '';
    return tipo != 'segreteria';
  },
};
